import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// ─── Refs ─────────────────────────────────────────────────────────────────────
const header = document.querySelector('header')
const btn    = document.getElementById('mobile-menu-btn')
const menu   = document.getElementById('mobile-menu')
const top    = document.getElementById('hamburger-top')
const mid    = document.getElementById('hamburger-mid')
const bot    = document.getElementById('hamburger-bot')

// ─── Mobile menu: toggle + hamburger → X ──────────────────────────────────────
let menuOpenedAt = 0

const closeMenu = () => {
  if (!menu || menu.classList.contains('hidden')) return
  menu.classList.add('hidden')
  btn.setAttribute('aria-expanded', 'false')
  btn.setAttribute('aria-label', 'Apri menu')
  if (top) top.style.transform = ''
  if (mid) mid.style.opacity   = '1'
  if (bot) bot.style.transform = ''
  if (header) header.style.transform = ''
}

if (btn && menu) {
  btn.addEventListener('click', () => {
    const isOpen = !menu.classList.toggle('hidden')
    menuOpenedAt = isOpen ? Date.now() : 0
    btn.setAttribute('aria-expanded', String(isOpen))
    btn.setAttribute('aria-label', isOpen ? 'Chiudi menu' : 'Apri menu')
    if (top) top.style.transform = isOpen ? 'translateY(6px) rotate(45deg)'   : ''
    if (mid) mid.style.opacity   = isOpen ? '0' : '1'
    if (bot) bot.style.transform = isOpen ? 'translateY(-6px) rotate(-45deg)' : ''
    if (header) header.style.transform = isOpen ? 'translateY(0)' : ''
  })
}

// ─── Close menu on scroll (ignore scroll bursts within 300ms of opening) ──────
window.addEventListener('scroll', () => {
  if (Date.now() - menuOpenedAt < 300) return
  closeMenu()
}, { passive: true })

// ─── Mobile menu: close before anchor scroll ──────────────────────────────────
if (menu) {
  menu.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(new URL(link.href).hash)
      if (!target) return
      e.preventDefault()
      closeMenu()
      // Wait for menu to collapse, then scroll with correct offset
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { target.scrollIntoView({ behavior: 'smooth', block: 'start' }) })
      })
    })
  })
}

// ─── Scrollspy ────────────────────────────────────────────────────────────────
const navLinks = document.querySelectorAll('[data-navlink]')
if (navLinks.length) {
  const sections = document.querySelectorAll('section[id]')
  const visible  = new Set()

  const setActive = (id) => {
    navLinks.forEach(link => {
      if (link.dataset.cta) return  // skip CTA outline button
      const isActive = link.dataset.navlink === id
      link.classList.toggle('text-complementary', isActive)
      link.classList.toggle('text-white',          !isActive)
    })
  }

  const updateActive = () => {
    if (!visible.size) return
    // Pick the topmost visible section
    const topmost = [...visible].sort(
      (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
    )[0]
    setActive(topmost.id)
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)
    })
    updateActive()
  }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 })

  sections.forEach(section => observer.observe(section))
}

// ─── Smart sticky header ───────────────────────────────────────────────────────
if (header) {
  let lastScrollY = 0
  const threshold = 80

  window.addEventListener('scroll', () => {
    if (menu && !menu.classList.contains('hidden')) return // don't hide while menu is open
    const currentScrollY = window.scrollY
    header.style.transform = (currentScrollY > lastScrollY && currentScrollY > threshold)
      ? 'translateY(-100%)'
      : 'translateY(0)'
    lastScrollY = currentScrollY
  }, { passive: true })
}
